module.exports = __webpack_public_path__ + "static/media/article16.6b3ad366.webp";